import {
  PROD_ENVIRONMENT_ROUTE,
  STAGING_ENVIRONMENT_ROUTE,
  DEV_ENVIRONMENT_ROUTE,
} from "@/constants/environment-routes";
import { PH_KEYS } from "badlands-shared";

export const isValidPosthogEnvironment = () => {
  try {
    return (
      window.location.hostname === PROD_ENVIRONMENT_ROUTE ||
      window.location.hostname === DEV_ENVIRONMENT_ROUTE ||
      window.location.hostname === STAGING_ENVIRONMENT_ROUTE
    );
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const captureEvent = (posthog, eventName, properties = {}) => {
  if (!isValidPosthogEnvironment()) return;
  if (!posthog) return;

  posthog.capture(eventName, properties);
};

export const trackEvent = (posthog, eventName) => (properties) => {
  captureEvent(posthog, eventName, properties);
};

export const posthogIdentifyUser = (posthog, user) => {
  if (!isValidPosthogEnvironment()) return;
  if (!posthog) return;

  const { WorkspaceConfig } = user.Workspaces[0] || {};
  const paymentMethod = WorkspaceConfig?.paymentMethod || null;
  const plan = WorkspaceConfig?.Plan || null;

  posthog.identify(user.id, {
    [PH_KEYS.USERNAME]: user.email,
    [PH_KEYS.FIRST_NAME]: user.firstName,
    [PH_KEYS.LAST_NAME]: user.lastName,
    [PH_KEYS.EMAIL]: user.email,
    [PH_KEYS.EMAIL_VERIFIED]: user.emailVerified,
    [PH_KEYS.AUTHENTICATION_METHOD]: user.provider,
    [PH_KEYS.JOB_FUNCTION]: user.jobFunction,
    [PH_KEYS.SIGNUP_AT]: user.createdAt,
    [PH_KEYS.REFERRAL_METHOD]: user.referralMethod,
    [PH_KEYS.WORKSPACE_CURRENT_PAYMENT_METHOD]: paymentMethod,
    [PH_KEYS.WORKSPACE_CURRENT_PLAN]: plan?.name,
  });
};

export const posthogIdentifyWorkspace = (posthog, user) => {
  if (!isValidPosthogEnvironment()) return;
  if (!posthog) return;

  const { Workspaces } = user;

  if (!Workspaces) return;

  const workspace = Workspaces[0];
  if (!workspace) return;

  const { WorkspaceConfig } = workspace;

  let Plan = null;
  if (WorkspaceConfig) {
    Plan = WorkspaceConfig.Plan;
  }

  posthog.group("workspace", workspace.id, {
    [PH_KEYS.WORKSPACE_ID]: workspace.id,
    [PH_KEYS.WORKSPACE_NAME]: workspace.name,
    [PH_KEYS.WORKSPACE_CURRENT_PLAN]: Plan?.name,
    [PH_KEYS.WORKSPACE_CREATED_AT]: workspace.createdAt,
  });
};

export const posthogReset = (posthog) => {
  if (!isValidPosthogEnvironment()) return;
  if (!posthog) return;

  posthog.reset();
};
